import { apiGet } from '../../api'

export const delete_venue = query => {
  return apiGet({
    endpoint: `venue/delete_venue?${query}`
  })
}
